{
    "Profile_Drivers_Conviction.drivingConviction": "Driving Conviction",
    "Profile_Drivers_Conviction.drivingConvictionDetails": "Driving Conviction Details",
    "Profile_Drivers_Conviction.dateOfConviction": "Date of Conviction",
    "Profile_Drivers_Conviction.convictionReason": "Conviction Reason"
}
